@if (event) {
  <div class="event-block">
    @if (event.book) {
      <img class="can-book" src="../../../assets/canVisit.png">
    }
    @if (event.picture) {
      <div  class="image">
        <img [src]="getEventImage(event.picture)">
      </div>
    }
    <div class="header-one">
      <div class="part-1 inline">
        <div class="part-1-1 height-30" [style.color]="'black'">{{_date}}</div>
        <div class="part-1-2 height-30" [style.backgroundColor]="opacityColor"></div>
      </div>
      <div class="part-2 inline">
        <div class="part-2-1 height-30" [style.borderBottomColor]="event.eventType.color"></div>
        <div class="part-2-2 height-30" [style.borderTopColor]="event.eventType.color"></div>
      </div>
      <div class="part-3 inline">
        <div class="part-3-1 height-30" [style.backgroundColor]="opacityColor" #tooltip="matTooltip"
        matTooltip="{{event.eventType.name}}"  [matTooltipPosition]="'above'">{{event?.eventType?.name}}</div>
        <div class="part-3-2 height-30" [style.color]="'black'">{{event?.credits ? event?.credits : ''}} {{event?.credits ? 'Credits' : ''}}</div>
      </div>
    </div>
    <div class="main-info">
      <div class="main-info-title">
        {{event.title}}
      </div>
      <div class="main-info-text" [innerHTML]="event.description">
      </div>
    </div>
  </div>
}
@if (event) {
  <div class="block-footer">
    <div class="block-footer-1">
    </div>
    <div class="block-footer-2">
      <div class="block-footer-2-1">
      </div>
    </div>
  </div>
}
